import React, { useState, Children } from 'react';
import { PlusIcon } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { motion, AnimatePresence } from 'framer-motion';
const CATEGORIES = ['All', 'Pain Relief', 'Allergy & Sinus', 'Skin Care', 'Digestive Health', 'Cold & Flu', 'Vitamins & Supplements'];
const PRODUCTS = [{
  id: 1,
  storeId: 'annapolis',
  name: 'Advanced Multivitamin Complex',
  category: 'Vitamins & Supplements',
  price: '$24.99',
  image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?q=80&w=800&auto=format&fit=crop'
}, {
  id: 2,
  storeId: 'annapolis',
  name: 'Nighttime Cough & Cold Relief',
  category: 'Cold & Flu',
  price: '$12.50',
  image: 'https://images.unsplash.com/photo-1550572017-ed20015dd085?q=80&w=800&auto=format&fit=crop'
}, {
  id: 3,
  storeId: 'annapolis',
  name: 'Extra Strength Pain Reliever',
  category: 'Pain Relief',
  price: '$9.99',
  image: 'https://images.unsplash.com/photo-1585435557343-3b092031a831?q=80&w=800&auto=format&fit=crop'
}, {
  id: 4,
  storeId: 'annapolis',
  name: 'Daily Immune Support (60ct)',
  category: 'Vitamins & Supplements',
  price: '$18.75',
  image: 'https://images.unsplash.com/photo-1471864190281-a93a3070b6de?q=80&w=800&auto=format&fit=crop'
}, {
  id: 5,
  storeId: 'dc',
  name: "Children's Allergy Relief",
  category: 'Allergy & Sinus',
  price: '$14.20',
  image: 'https://images.unsplash.com/photo-1631549916768-4119b2e5f926?q=80&w=800&auto=format&fit=crop'
}, {
  id: 6,
  storeId: 'dc',
  name: 'Moisturizing Skin Therapy',
  category: 'Skin Care',
  price: '$11.45',
  image: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?q=80&w=800&auto=format&fit=crop'
}, {
  id: 7,
  storeId: 'dc',
  name: 'Rapid Response First Aid Kit',
  category: 'Pain Relief',
  price: '$29.99',
  image: 'https://cdn.magicpatterns.com/uploads/xdNDKr9wN59hCtzteEJdbE/pasted-image.jpg'
}, {
  id: 8,
  storeId: 'dc',
  name: 'Digital Instant Thermometer',
  category: 'Cold & Flu',
  price: '$34.50',
  image: 'https://cdn.magicpatterns.com/uploads/xdNDKr9wN59hCtzteEJdbE/pasted-image.jpg'
}, {
  id: 9,
  storeId: 'annapolis',
  name: 'Antacid Maximum Strength',
  category: 'Digestive Health',
  price: '$8.99',
  image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?q=80&w=800&auto=format&fit=crop'
}, {
  id: 10,
  storeId: 'dc',
  name: 'Probiotic Wellness Capsules',
  category: 'Digestive Health',
  price: '$21.50',
  image: 'https://images.unsplash.com/photo-1471864190281-a93a3070b6de?q=80&w=800&auto=format&fit=crop'
}];
export function ProductGrid({
  storeId,
  searchQuery
}: {
  storeId?: string;
  searchQuery?: string;
}) {
  const {
    addToCart
  } = useCart();
  const [activeCategory, setActiveCategory] = useState('All');
  let filteredProducts = storeId ? PRODUCTS.filter(p => p.storeId === storeId) : PRODUCTS;
  if (activeCategory !== 'All') {
    filteredProducts = filteredProducts.filter(p => p.category === activeCategory);
  }
  if (searchQuery) {
    const query = searchQuery.toLowerCase();
    filteredProducts = filteredProducts.filter(p => p.name.toLowerCase().includes(query) || p.category.toLowerCase().includes(query));
  }
  const storeName = storeId === 'annapolis' ? 'Annapolis' : storeId === 'dc' ? 'Washington D.C.' : 'All Locations';
  return <section className="py-12 sm:py-24 bg-white border-y border-slate-100" data-id="element-231">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-232">
        <div className="mb-12 flex flex-col lg:flex-row lg:items-end justify-between gap-10" data-id="element-233">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="max-w-xl" data-id="element-234">
            <div className="inline-flex items-center gap-3 px-4 py-1.5 bg-clinical-blue text-white rounded-full text-[10px] font-black uppercase tracking-[0.2em] mb-6 shadow-lg shadow-clinical-blue/20" data-id="element-235">
              <span className="relative flex h-2 w-2" data-id="element-236">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" data-id="element-237"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-white" data-id="element-238"></span>
              </span>
              Browsing: {storeName} Store
            </div>
            <h2 className="text-4xl sm:text-5xl font-black text-slate-900 mb-3 uppercase tracking-tighter leading-none" data-id="element-239">
              {searchQuery ? `${filteredProducts.length} Result${filteredProducts.length !== 1 ? 's' : ''}` : 'Shop Wellness Essentials'}
            </h2>
            <p className="text-slate-400 text-xs sm:text-sm uppercase tracking-[0.2em] font-bold" data-id="element-240">
              Premium Over-the-counter retail
            </p>
          </motion.div>

          {!searchQuery && <div className="flex flex-wrap gap-2 lg:justify-end max-w-2xl" data-id="element-241">
              {CATEGORIES.map(cat => <button key={cat} onClick={() => setActiveCategory(cat)} className={`px-5 py-2.5 rounded-full text-[10px] font-black uppercase tracking-widest transition-all duration-300 ${activeCategory === cat ? 'bg-clinical-blue text-white shadow-xl shadow-clinical-blue/20 scale-105' : 'bg-slate-50 text-slate-400 hover:bg-slate-100 hover:text-slate-600'}`} data-id="element-242">
                  {cat}
                </button>)}
            </div>}
        </div>

        <AnimatePresence mode="wait" data-id="element-243">
          <motion.div key={activeCategory + (searchQuery || '')} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} transition={{
          duration: 0.3
        }} data-id="element-244">
            {filteredProducts.length === 0 ? <div className="py-12 sm:py-20 text-center" data-id="element-245">
                <p className="text-slate-500 text-base sm:text-lg mb-2" data-id="element-246">
                  No products found in this category.
                </p>
                <button onClick={() => setActiveCategory('All')} className="text-clinical-blue font-bold uppercase tracking-widest text-[10px] hover:underline" data-id="element-247">
                  View all products
                </button>
              </div> : <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-10" data-id="element-248">
                {filteredProducts.map((product, idx) => <motion.div key={product.id} initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              delay: idx % 4 * 0.05
            }} className="group flex flex-col" data-id="element-249">
                    <div className="relative aspect-[4/5] overflow-hidden rounded-lg bg-clean-grey mb-6" data-id="element-250">
                      <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" onError={e => {
                  e.currentTarget.onerror = null; // Prevent infinite loop
                  e.currentTarget.src = 'https://cdn.magicpatterns.com/uploads/xdNDKr9wN59hCtzteEJdbE/pasted-image.jpg';
                }} data-id="element-251" />
                    </div>
                    <h3 className="font-bold text-slate-900 mb-1 text-sm leading-tight group-hover:text-clinical-blue transition-colors" data-id="element-252">
                      {product.name}
                    </h3>
                    <p className="text-lg font-black text-slate-900 mb-6 mt-auto" data-id="element-253">
                      {product.price}
                    </p>
                    <button onClick={() => addToCart(product)} className="w-full py-3 bg-clinical-blue text-white text-[10px] font-bold uppercase tracking-widest rounded hover:bg-blue-700 transition-all active:scale-95" data-id="element-254">
                      Add to Cart
                    </button>
                  </motion.div>)}
              </div>}
          </motion.div>
        </AnimatePresence>
      </div>
    </section>;
}